import { nextTick } from 'vue'
import Vuebar from 'vuebar/vuebar.js'

let vuebarApi = null
let vuebarDirective = null

function applyVuebarFallback (el) {
  el.classList.add('vb', 'vb-visible')
  el.style.position = 'relative'
  el.style.overflow = 'hidden'

  const content = el.firstElementChild
  if (!content) return

  content.classList.add('vb-content')
  content.style.display = 'block'
  content.style.overflowX = 'hidden'
  content.style.overflowY = 'auto'
  content.style.height = '100%'
}

function createFakeVue2 () {
  const fakeVue = {
    util: {
      warn (message) {
        console.warn(message)
      }
    },
    nextTick (callback) {
      return nextTick(callback)
    },
    prototype: {},
    directive (name, definition) {
      vuebarDirective = definition
    }
  }

  Vuebar.install(fakeVue)
  vuebarApi = fakeVue.vuebar

  return fakeVue
}

function initVuebar (el, binding) {
  if (!vuebarDirective?.inserted) {
    applyVuebarFallback(el)
    return
  }

  try {
    vuebarDirective.inserted.call(null, el, binding)
  } catch (error) {
    console.warn('vuebar init failed, using fallback scrollbar:', error)
    applyVuebarFallback(el)
  }
}

export function createVuebarCompatPlugin () {
  if (!vuebarApi) {
    createFakeVue2()
  }

  return {
    install (app) {
      app.config.globalProperties.$vuebar = vuebarApi

      app.directive('bar', {
        mounted (el, binding) {
          nextTick(() => {
            initVuebar(el, binding)
          })
        },
        updated (el, binding) {
          if (!vuebarDirective?.componentUpdated) return
          try {
            vuebarDirective.componentUpdated.call(null, el, binding)
          } catch (error) {
            console.warn('vuebar refresh failed:', error)
          }
        },
        unmounted (el, binding) {
          if (!vuebarDirective?.unbind) return
          try {
            vuebarDirective.unbind.call(null, el, binding)
          } catch (error) {
            console.warn('vuebar destroy failed:', error)
          }
        }
      })
    }
  }
}
